export default __webpack_public_path__ + "static/media/16.4d4ea696.jpg";